/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import useUtils from './useUtils'
import Papa from 'papaparse'
import {unparse} from 'papaparse'
import Pagination from '../../modules/pagination/Pagination'
import VideoListSk from '../../modules/skeleton/VideolistSK'
import saveAs from 'file-saver'
import CSVModal from '../../modules/modal/CSVModal'
import {showAlert} from '../../redux/reducers/alertSlice'
import CustomFilterDropdown from '../../modules/common/CustomFilterDropdown'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import reloadIcon from '../../../_metronic/assets/custom-icons/reload.png'
import calender from '../../../_metronic/assets/custom-icons/calendar.png'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'

const VideoListView = ({className, close}) => {
  const {
    fetchProgram,
    submitReport,
    fetchCourse,
    fetchModule,
    fetchUnit,
    fetchVideos,
    deleteVideo,
    handleEdit,
    addCSV,
    fetchAllVideos,
    refetchVideo,
  } = useUtils()
  const fileInputRef = useRef(null)
  const [searchTerm, setSearchTerm] = useState()
  const [loading, setLoading] = useState(true)
  const [retryLoading, setRetryLoading] = useState(false)
  const [id, setId] = useState(null)
  const [uploadLoading, setUploadLoading] = useState(false)
  const previousSearchTerm = useRef('')
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)
  const [videos, setVideos] = useState()
  const [isOpen, setIsOpen] = useState(false)
  const [csvData, setcsvData] = useState(null)
  const [isUpload, setIsUpload] = useState(false)

  const [selectedProgram, setSelectedProgram] = useState(null)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [selectedModule, setSelectedModule] = useState(null)
  const [selectedUnit, setSelectedUnit] = useState(null)

  const [programOptions, setProgramOptions] = useState([])
  const [courseOptions, setCourseOptions] = useState([])
  const [moduleOptions, setModuleOptions] = useState([])
  const [unitOptions, setUnitOptions] = useState([])

  const [programNextPageToken, setProgramNextPageToken] = useState(null)
  const [courseNextPageToken, setCourseNextPageToken] = useState(null)
  const [moduleNextPageToken, setModuleNextPageToken] = useState(null)
  const [unitNextPageToken, setUnitNextPageToken] = useState(null)

  const [isLoadingPrograms, setIsLoadingPrograms] = useState(false)
  const [isLoadingCourses, setIsLoadingCourses] = useState(false)
  const [isLoadingModules, setIsLoadingModules] = useState(false)
  const [isLoadingUnits, setIsLoadingUnits] = useState(false)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedVideoId, setSelectedVideoId] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Video'))

  const getVideos = async () => {
    try {
      if (searchTerm === previousSearchTerm.current) {
        setLoading(true)
      }
      const offset = (page - 1) * limit
      const videoData = await fetchVideos(
        searchTerm,
        limit,
        offset,
        selectedProgram,
        selectedCourse,
        selectedModule,
        selectedUnit,
        ['unitVideo.unit', 'language']
      )
      setVideos(videoData)
      setTotalPages(Math.ceil(videoData.count / limit))
      previousSearchTerm.current = searchTerm
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleReload = async(id) => {
    try{
      setRetryLoading(true)
      setId(id)
      const response = await refetchVideo(id) 
      if(response){
        setVideos((prevVideos) => {
          const updatedRecords = prevVideos.records.map((video) => {
            if (video.id === id) {
              return {...video, status: response.status, errorMessage: response.errorMessage}
            }
            return video
          })
          return {...prevVideos, records: updatedRecords}
        })
      }
    }catch (error) {}
    finally{
      setRetryLoading(false)
      setId(null)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        getVideos()
      },
      searchTerm ? 500 : 0
    )
    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, page, limit, selectedProgram, selectedCourse, selectedModule, selectedUnit])

  const loadMorePrograms = async () => {
    if (isLoadingPrograms || !programNextPageToken) return

    setIsLoadingPrograms(true)
    try {
      const response = await fetchProgram(programNextPageToken)
      if (response) {
        setProgramOptions((prev) => [...prev, ...response.records])
        setProgramNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more programs:', error)
    } finally {
      setIsLoadingPrograms(false)
    }
  }

  const loadMoreCourses = async () => {
    if (isLoadingCourses || !courseNextPageToken || !selectedProgram) return

    setIsLoadingCourses(true)
    try {
      const response = await fetchCourse(selectedProgram, courseNextPageToken)
      if (response) {
        setCourseOptions((prev) => [...prev, ...response.records])
        setCourseNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more courses:', error)
    } finally {
      setIsLoadingCourses(false)
    }
  }

  const loadMoreModules = async () => {
    if (isLoadingModules || !moduleNextPageToken || !selectedCourse) return

    setIsLoadingModules(true)
    try {
      const response = await fetchModule(selectedCourse, moduleNextPageToken)
      if (response) {
        setModuleOptions((prev) => [...prev, ...response.records])
        setModuleNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more modules:', error)
    } finally {
      setIsLoadingModules(false)
    }
  }

  const loadMoreUnits = async () => {
    if (isLoadingUnits || !unitNextPageToken || !selectedModule) return

    setIsLoadingUnits(true)
    try {
      const response = await fetchUnit(selectedModule, unitNextPageToken)
      if (response) {
        setUnitOptions((prev) => [...prev, ...response.records])
        setUnitNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more units:', error)
    } finally {
      setIsLoadingUnits(false)
    }
  }

  const fetchInitialData = async () => {
    try {
      const programs = await fetchProgram()
      if (programs) {
        setProgramOptions(programs.records)
        setProgramNextPageToken(programs.nextPageToken)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchInitialData()
  }, [])

  const handleProgramChange = async (programId) => {
    setSelectedProgram(programId)
    setSelectedCourse(null)
    setSelectedModule(null)
    setSelectedUnit(null)

    setCourseOptions([])
    setCourseNextPageToken(null)
    setModuleOptions([])
    setModuleNextPageToken(null)
    setUnitOptions([])
    setUnitNextPageToken(null)

    if (programId) {
      setIsLoadingCourses(true)
      try {
        const courses = await fetchCourse(programId)
        if (courses) {
          setCourseOptions(courses.records)
          setCourseNextPageToken(courses.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading courses:', error)
      } finally {
        setIsLoadingCourses(false)
      }
    }
  }

  const handleCourseChange = async (courseId) => {
    setSelectedCourse(courseId)
    setSelectedModule(null)
    setSelectedUnit(null)

    setModuleOptions([])
    setModuleNextPageToken(null)
    setUnitOptions([])
    setUnitNextPageToken(null)

    if (courseId) {
      setIsLoadingModules(true)
      try {
        const modules = await fetchModule(courseId)
        if (modules) {
          setModuleOptions(modules.records)
          setModuleNextPageToken(modules.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading modules:', error)
      } finally {
        setIsLoadingModules(false)
      }
    }
  }

  const handleModuleChange = async (moduleId) => {
    setSelectedModule(moduleId)
    setSelectedUnit(null)

    setUnitOptions([])
    setUnitNextPageToken(null)

    if (moduleId) {
      setIsLoadingUnits(true)
      try {
        const units = await fetchUnit(moduleId)
        if (units) {
          setUnitOptions(units.records)
          setUnitNextPageToken(units.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading units:', error)
      } finally {
        setIsLoadingUnits(false)
      }
    }
  }

  const handleUnitChange = async (unitId) => {
    setSelectedUnit(unitId)
  }

  const onEdit = async (id) => {
    const values = await handleEdit(id)
    navigate('/videolist/editvideo', {state: {values}})
  }

  const onDelete = (id) => {
    setSelectedVideoId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedVideoId) return
    try {
      const response = await deleteVideo(selectedVideoId)
      setVideos(response)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setModalVisible(false)
      setSelectedVideoId(null)
    }
  }

  const handleDownload = async () => {
    try {
      setDownloadLoading(true)
      const data = await fetchAllVideos(
        searchTerm,
        selectedProgram,
        selectedCourse,
        selectedModule,
        selectedUnit
      )
      const csv = unparse(data, {header: true})
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, 'videos.csv')
    } catch (error) {
      console.error('Error downloading videos:', error)
    } finally {
      setDownloadLoading(false)
    }
  }

  const uploadFile = async (data) => {
    let successRecords = 0
    const failedRecords = []
    try {
      if (data.length <= 100) {
        const response = await addCSV(data)
        if (response) {
          if (response.success) {
            console.log(response.success)
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed)
          }

          const successMessage = response.success
            ? `${successRecords} videos uploaded successfully`
            : ''
          const failedMessage =
            response.failed?.length > 0 ? `${response.failed.length} videos failed to upload` : ''
          const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
          dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
        }
      } else {
        const chunkSize = 100
        const chunks = []
        for (let i = 0; i < data.length; i += chunkSize) {
          chunks.push(data.slice(i, i + chunkSize))
        }
        const uploadPromises = chunks.map((chunk) => addCSV(chunk))
        const responses = await Promise.all(uploadPromises)

        responses.forEach((response) => {
          if (response.success) {
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed)
          }
        })

        const successMessage = successRecords
          ? `${successRecords} videos uploaded successfully`
          : ''
        const failedMessage = failedRecords.length
          ? `${failedRecords.length} videos failed to upload`
          : ''
        const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
        dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
      }

      const finalSummary = {
        recordType: 'Videos',
        totalRecords: data.length,
        successRecords: successRecords,
        failedRecords: failedRecords,
      }

      const res = await submitReport(finalSummary)
      if (res) {
        dispatch(
          showAlert({message: 'Report Submitted Successfully', variant: 'info', timeout: 5000})
        )
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.error('Error uploading course:', error)
    } finally {
      setUploadLoading(false)
    }
  }

  const handleFileChange = (event) => {
    setUploadLoading(true)
    const file = event.target.files[0]
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            setIsOpen(true)
            setcsvData(result?.data)
            event.target.value = null
          },
          error: (error) => {
            console.error('Error parsing CSV:', error)
          },
        })
      } else {
        dispatch(showAlert({message: 'Please select a valid CSV file.', variant: 'danger'}))
      }
    }
  }

  useEffect(() => {
    if (csvData) {
      const transformedData = csvData?.map((obj, index) => ({
        id: obj?.id,
        title: obj?.title,
        link: obj?.link,
        description: obj?.description,
        tags: obj.tags ? obj.tags.split(',').map((tag) => tag.trim()) : [],
        duration: parseInt(obj?.duration) || 0,
        status: obj?.status,
        unitId: obj?.unit,
        languageId: obj?.language,
      }))

      const dataToUpload = transformedData.slice(0, -1)

      uploadFile(dataToUpload)
      setcsvData(null)
      getVideos()
    }
  }, [isUpload])

  if (loading) return <VideoListSk />

  return (
    <>
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start '>
            <span className=' mt-1 text-muted fs-7 '>
              {videos?.count} {videos?.count <= 1 ? 'Item' : 'items'}
            </span>
          </h3>
          {/* begin::Search */}
          <div className='d-flex align-items-center justify-content-between w-100 flex-wrap'>
            <div className='d-flex align-items-center flex-wrap gap-3'>
              <div className='d-flex align-items-center'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-6'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid fs-7 w-250px ps-14'
                  placeholder='Search Videos'
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    setPage(1)
                  }}
                />
              </div>

              <div>
                <CustomFilterDropdown
                  options={programOptions}
                  selectedValue={selectedProgram}
                  onChange={handleProgramChange}
                  onScrollEnd={loadMorePrograms}
                  isLoading={isLoadingPrograms}
                  placeholder='Select Program'
                  displayField='title'
                />
              </div>

              {selectedProgram && (
                <div>
                  <CustomFilterDropdown
                    options={courseOptions}
                    selectedValue={selectedCourse}
                    onChange={handleCourseChange}
                    onScrollEnd={loadMoreCourses}
                    isLoading={isLoadingCourses}
                    placeholder='Select Course'
                    displayField='title'
                  />
                </div>
              )}

              {selectedCourse && (
                <div>
                  <CustomFilterDropdown
                    options={moduleOptions}
                    selectedValue={selectedModule}
                    onChange={handleModuleChange}
                    onScrollEnd={loadMoreModules}
                    isLoading={isLoadingModules}
                    placeholder='Select Module'
                    displayField='title'
                  />
                </div>
              )}

              {selectedModule && (
                <div>
                  <CustomFilterDropdown
                    options={unitOptions}
                    selectedValue={selectedUnit}
                    onChange={handleUnitChange}
                    onScrollEnd={loadMoreUnits}
                    isLoading={isLoadingUnits}
                    placeholder='Select Unit'
                    displayField='name'
                  />
                </div>
              )}
            </div>
            <div className='card-toolbar'>
              <img
                src={calender}
                className='me-5'
                onClick={() => close()}
                style={{cursor: 'pointer', height: '24px', width: '24px'}}
                title="Switch to Grid View"
              />
              <div>
                <span
                  onClick={() => fileInputRef.current.click()}
                  className='btn btn-sm btn-light-primary me-2'
                >
                  {uploadLoading ? (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/files/fil010.svg' className='svg-icon-2' />
                      Upload CSV
                    </>
                  )}
                </span>
                <input
                  type='file'
                  ref={fileInputRef}
                  style={{display: 'none'}}
                  accept='.csv'
                  onChange={handleFileChange}
                />
              </div>

              <span onClick={() => handleDownload()} className='btn btn-sm btn-light-primary me-2'>
                {downloadLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    <KTSVG
                      path='/media/icons/duotune/files/fil003.svg'
                      className='svg-icon-2 me-1'
                    />
                    Download CSV
                  </>
                )}
              </span>

              <span
                onClick={() => navigate('/videolist/addvideo')}
                className='btn btn-sm btn-light-primary'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                Add Video
              </span>
            </div>
          </div>
        </div>
        {/* end::Header */}

        {videos?.count === 0 && (
          <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
            <div className='card-body text-center'>
              <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
              </span>
              <h4 className='mb-1'>No Records Found</h4>
              <span>Add more Videos or change the filters</span>
            </div>
          </div>
        )}

        {videos?.count > 0 && (
          <div className='card-body py-10'>
            <div className='table-responsive'>
              <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                <thead className='align-top'>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-100px'>ID</th>
                    <th className='min-w-150px text-left'>Title</th>
                    <th className='min-w-200px'>Description</th>
                    <th className='min-w-100px'>Duration</th>
                    <th className='min-w-100px'>Unit</th>
                    <th className='min-w-100px'>Language</th>
                    <th className='min-w-100px'>Status</th>
                    <th className='text-end'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {videos?.records &&
                    videos?.records.map((value, index) => {
                      return (
                        <tr key={index}>
                          <td className='text-nowrap'>
                            <span className='text-dark fw-bold fs-6'>
                              {value.id}
                            </span>
                          </td>
                          <td className='text-left ps-4'>
                            <span className='text-dark fw-bold fs-6'>
                              {value?.title?.length > 30 ? value.title.slice(0, 30) + '...' : value.title}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-bold fs-6'>
                              {value?.description?.length > 50 ? value.description.slice(0, 50) + '...' : value.description}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-bold fs-6'>
                              {value?.duration}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-bold fs-6'>
                              {value?.unitVideo[0]?.unit?.name || 'N/A'}
                            </span>
                          </td>
                          <td>
                            <span className='text-dark fw-bold fs-6'>
                              {value?.language?.name || 'N/A'}
                            </span>
                          </td>
                          <td>
                            <div className='d-flex align-items-center'>
                              <span 
                                className={`badge ${
                                  value?.status === 'active' 
                                    ? 'badge-light-success' 
                                    : value?.status === 'pending' 
                                    ? 'badge-light-danger' 
                                    : 'badge-light-warning'
                                }`}
                              >
                                {value?.status || 'Unknown'}
                              </span>
                              {(value.status === 'pending' || value.status === 'warning') && value.errorMessage && (
                                <div className='d-flex gap-1 align-items-center ms-2'>
                                  <OverlayTrigger
                                    placement='top'
                                    overlay={
                                      <Tooltip id={`tooltip-pending-${value.id}`}>
                                        {value.errorMessage}
                                      </Tooltip>
                                    }
                                  >
                                    <span style={{cursor: 'pointer', color: '#FFA500'}}>
                                      <KTSVG
                                        path='/media/icons/duotune/general/gen044.svg'
                                        className={`svg-icon-1 ${value.status === 'pending' ? 'text-danger' : 'text-warning'}`}
                                      />
                                    </span>
                                  </OverlayTrigger>
                                  {retryLoading && value.id === id ? (
                                    <div className='spinner-border spinner-border-sm align-middle ms-2'></div>
                                  ) : (
                                    <img 
                                      className='cursor-pointer' 
                                      onClick={() => handleReload(value.id)} 
                                      src={reloadIcon} 
                                      style={{height:'19px'}}
                                      alt="Reload"
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          </td>
                          <td className='d-flex justify-content-end'>
                            <span
                              onClick={() => onEdit(value.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-3 svg-icon-primary'
                              />
                            </span>
                            <span
                              onClick={() => onDelete(value.id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3 text-danger'
                              />
                            </span>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          {isOpen && (
            <CSVModal
              show={isOpen}
              upload={() => setIsUpload((prev) => !prev)}
              handleClose={() => {
                setIsOpen(false)
                setUploadLoading(false)
              }}
              handleCancel={() => {
                setIsOpen(false)
                setUploadLoading(false)
              }}
              csvData={csvData}
              optionalFields={['description', 'isActive']}
            />
          )}
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
      <DeleteConfirmation
        isVisible={modalVisible}
        message="Are you sure you want to delete this video?"
        onConfirm={confirmDelete}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}

export default VideoListView 